import { render, staticRenderFns } from "./AccountSettingsPage.vue?vue&type=template&id=08d8940a&scoped=true"
import script from "./AccountSettingsPage.vue?vue&type=script&lang=js"
export * from "./AccountSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsPage.vue?vue&type=style&index=0&id=08d8940a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8940a",
  null
  
)

export default component.exports